import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import { CompanyFilterRequest } from '@/main/models/request';

export abstract class ICompanyApi {
  abstract getDomain(
    request: CompanyFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getDomainAll(
    request: CompanyFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
